import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-lg" data-testid="payment-cancel">
        <XCircle className="mx-auto text-neutral-500" size={44} />
        <h1 className="font-serif text-5xl font-light mt-6">Checkout cancelled</h1>
        <p className="text-neutral-400 mt-3">No charge was made. Your selection is safe — pick up where you left off whenever you're ready.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/gallery" className="btn-amber rounded-full px-6 py-3">Back to gallery</Link>
          <Link to="/" className="border border-white/20 rounded-full px-6 py-3 hover:border-amber-glow">Home</Link>
        </div>
      </div>
    </div>
  );
}
